module.exports = new __parcel__URL__("noaa-air-samples--cover.77397635.png").toString();